import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matTagRound } from '@ng-icons/material-symbols/round';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-styled-text-control',
  templateUrl: 'styled-text-control.component.html',
  styleUrls: ['styled-text-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent, NgIconComponent],
  providers: [
    provideIcons({ matTagRound }),
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormStyledTextControlComponent,
    },
  ],
})
export class DynamicFormStyledTextControlComponent extends AbstractDynamicFormControl {}
